import React, {useContext} from 'react';
import {Label} from 'reactstrap';
import Translate from '@src/components/Translate/Translate';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import classnames from '@src/helpers/classnames';

export default function FieldLayout({id, label, children, className, ...props}: {
    id: string | null,
    label: string,
    children: React.ReactNode,
    className?: string,
    style?: React.CSSProperties,
}) {
    const [design] = useContext(FormFieldDesignContext);

    return <div
            className={classnames(design.wrapperClass, className ?? 'mb-3')}
            {...props}
    >
        <Label htmlFor={id ?? undefined} size={design.size}>
            <Translate message={label}/>
        </Label>

        {children}
    </div>;
}
